import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InitFilterRecordsService } from '@services/init-filter-records/init-filter-records.service';
import { ChangePasswordComponent } from './auth/change-password/change-password.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { LoginComponent } from './auth/login/login.component';
import { ContainersComponent } from './components/containers/containers.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { RecordsComponent } from './components/records/records.component';
import { UserEditComponent } from './components/users/user-edit/user-edit.component';
import { UsersManagementComponent } from './components/users/users-management/users-management.component';
import { AdminGuard } from './shared/guards/admin.guard';
import { AuthGuard } from './shared/guards/auth.guard';
import { ChangePwdGuard } from './shared/guards/change-pwd.guard';
import { UnauthGuard } from './shared/guards/unauth.guard';


const routes: Routes = [
  {
    path: 'login', component: LoginComponent,
    canActivate: [UnauthGuard],
    data: { title: 'auth.login.title' }
  },
  {
    path: 'login/forgot-password', component: ForgotPasswordComponent,
    // canActivate: [UnauthGuard],
    data: { title: 'auth.forgotPassword' }
  },
  {
    path: 'change-password', component: ChangePasswordComponent,
    canActivate: [ChangePwdGuard],
    data: { title: 'auth.changePassword.title' }
  },
  {
    path: 'dashboard', component: DashboardComponent,
    canActivate: [AuthGuard, AdminGuard],
    data: { title: 'Tableau de bord' }
  },
  {
    path: 'users', component: UsersManagementComponent,
    canActivate: [AuthGuard, AdminGuard],
    data: { title: 'Gestion des utilisateur' }
  },
  {
    path: 'user-details', component: UserEditComponent,
    canActivate: [AuthGuard, AdminGuard],
    data: { title: 'Détails utilisateurs' }
  },
  {
    path: 'records', component: RecordsComponent,
    canActivate: [AuthGuard, AdminGuard],
    data: { title: 'Encodages' }
  },
  {
    path: 'clicotte', component: ContainersComponent,
    canActivate: [AuthGuard, AdminGuard],
    data: { title: 'Clicotte' }
  },

  // { path: 'error', component: ErrorComponent, data: { title: 'error' } },
  { path: '**', redirectTo: 'login', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
